var render, staticRenderFns
import script from "./DepartmentHome.vue?vue&type=script&lang=js"
export * from "./DepartmentHome.vue?vue&type=script&lang=js"
import style0 from "./DepartmentHome.vue?vue&type=style&index=0&id=0d1e1ef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e1ef3",
  null
  
)

export default component.exports